module.exports = __webpack_public_path__ + "img/png8.9839ed92.png";